import { render } from "./PortfolioIndustryGenome.vue?vue&type=template&id=001d5bc6"
import script from "./PortfolioIndustryGenome.vue?vue&type=script&lang=js"
export * from "./PortfolioIndustryGenome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__